import { getStatusColor } from './colorUtils'
import { ApprovalStatus } from '../api/models'

// Approval status utilities with centralized color management
export interface ApprovalStatusInfo {
  text: string
  color: string
}

export const getApprovalStatusInfo = (approvalStatus?: string | ApprovalStatus): ApprovalStatusInfo => {
  // Handle both string and enum values
  const status = typeof approvalStatus === 'number' ? approvalStatus : approvalStatus?.toUpperCase()

  if (status === ApprovalStatus.Approved || status === 'APPROVED') {
    return {
      text: 'Approved',
      color: getStatusColor('success'),
    }
  }

  if (status === ApprovalStatus.Rejected || status === 'REJECTED') {
    return {
      text: 'Rejected',
      color: getStatusColor('danger'),
    }
  }

  // Everything else is considered pending (including undefined, null, and not approved states)
  return {
    text: 'Pending',
    color: getStatusColor('warning'),
  }
}

export const isApproved = (approvalStatus?: string | ApprovalStatus): boolean => {
  if (typeof approvalStatus === 'number') {
    return approvalStatus === ApprovalStatus.Approved
  }
  return approvalStatus?.toUpperCase() === 'APPROVED'
}

export const isRejected = (approvalStatus?: string | ApprovalStatus): boolean => {
  if (typeof approvalStatus === 'number') {
    return approvalStatus === ApprovalStatus.Rejected
  }
  return approvalStatus?.toUpperCase() === 'REJECTED'
}

export const isPending = (approvalStatus?: string | ApprovalStatus): boolean => {
  if (typeof approvalStatus === 'number') {
    return approvalStatus === ApprovalStatus.NotApproved
  }
  const status = approvalStatus?.toUpperCase()
  return status === 'PENDING' || status === 'NOTAPPROVED' || !status
}
